import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, checked } = useAuth();
  const location = useLocation();
  if (!checked || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (
    user?.role === "magazzino_alluminio" &&
    !location.pathname.startsWith("/gestionale/magazzino-alluminio")
  ) {
    return <Navigate to="/gestionale/magazzino-alluminio" replace />;
  }
  return children;
}

